<template>
  <div class="charts-pie"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ChartsPie',
  props: {
    data1: {
      type: Object,
      required: true,
    },
    data2: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colors: ['#91cc75', '#5470c6', '#fac858','#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd'],
      chartName1: '各类任务数',
      chartName2: '各类任务算力数',
    }
  },
  watch: {
    data1: {
      deep: true,
      handler() {
        this.update();
      },
    },
    data2: {
      deep: true,
      handler() {
        this.update();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$el);
      window.addEventListener('resize', () => this.chart.resize());
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', () => this.chart.resize());
        this.chart.dispose();
      });
      this.update();
    },
    update() {
      if (!this.chart) return;
      const { data1, data2,  colors, chartName1, chartName2 } = this;
        // 提取图例项
      const option = {
        legend: {
          top: 0,
          right: 50, // 增加图例与右侧的距离
          itemWidth: 6,
          itemHeight: 6,
          icon: 'rect',
          textStyle: {
            color: 'rgba(255,255,255,0.5)',
            fontFamily: '"OPPOSans R",sans-serif',
          },
        },
        series: [
          // 第一个饼图
          {
            name: chartName1,
            type: 'pie',
            clockwise: false,
            radius: '60%',
            center: ['20%', '50%'],
            avoidLabelOverlap: false,
            // hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: { show: false },
            data: data1.map((item, index) => ({
              ...item,
              itemStyle: {
                color: colors[index % colors.length], // 循环使用颜色
              },
            })),
          },
          // 第二个饼图
          {
            name: chartName2,
            type: 'pie',
            clockwise: false,
            radius: '60%',
            center: ['65%', '50%'], // 中心点位置
            avoidLabelOverlap: false,
            // hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: { show: false },
            data: data2.map((item, index) => ({
              ...item,
              itemStyle: {
                color: colors[index % colors.length], // 循环使用颜色
              },
            })),
          },
        ],
        graphic: [
          // 第一个玫瑰图标题
          {
            type: 'text',
            left: '10%',
            bottom: '0px',
            z: 100,
            style: {
              text: chartName1,
              textAlign: 'center',
              fill: '#f5f5f5', // 文字颜色
              fontSize: 12,
              fontFamily: '"OPPOSans R",sans-serif',
            },
          },
          // 第二个玫瑰图标题
          {
            type: 'text',
            right: '25%',
            bottom: '0px',
            z: 100,
            style: {
              text: chartName2,
              textAlign: 'center',
              fill: '#f5f5f5', // 文字颜色
              fontSize: 12,
              fontFamily: '"OPPOSans R",sans-serif',
            },
          },
        ]
      };

      this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.charts-pie {
  margin: 0;
  padding: 0;
  width: 420px; /* 调整宽度以适应两个饼图 */
  height: 130px;
}
</style>
